export const PrimaryColor = 'blue';
export const White = 'white';

export const Black = '#000000';
export const Transparent = '#00000065';
export const Grey = '#757575';
export const LightGrey = '#c6c6c6';
export const grey = '#F0F0FC';
export const SkyBlue = '#09BAE9';
export const ColorPrimary = '#21A50C';
export const ColorSecondary = '#FFFFFF';
export const LightBlue = 'lightblue';